import { SITE_URL } from "@/mocks/site";

interface PageMetaProps {
  title: string;
  description: string;
  keywords?: string;
  path: string;
  ogType?: "website" | "article";
  image?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const DEFAULT_OG_IMAGE =
  "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20film%20set%20scene%20with%20warm%20amber%20spotlights%2C%20deep%20crimson%20velvet%20curtains%2C%20soft%20bokeh%20light%20orbs%2C%20analog%20film%20grain%2C%20moody%20editorial%20atmosphere%2C%20minimalist%20composition%2C%20high%20detail&width=1600&height=900&seq=chigua-hero-01&orientation=landscape";

export default function PageMeta({
  title,
  description,
  keywords,
  path,
  ogType = "website",
  image,
  jsonLd,
}: PageMetaProps) {
  const canonical = `${SITE_URL}${path}`;
  const ogImage = image ?? DEFAULT_OG_IMAGE;
  const jsonLdList = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : [];
  const lastModified = new Date().toISOString().slice(0, 10);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content="index,follow" />
      <meta name="last-modified" content={lastModified} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="吃瓜片场" />
      <meta property="og:locale" content="zh_CN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLdList.map((item, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </>
  );
}